import { graphql } from "react-relay";

export const TriggerIdentityProviderSyncMutation = graphql`
  mutation TriggerIdentityProviderSyncMutation(
    $input: TriggerIdentityProviderSyncInput!
  ) {
    triggerIdentityProviderSync(input: $input) {
      problems {
        message
      }
    }
  }
`;
